import { useEffect, useState } from "react";

/**
 * Resolves the DOM element a portalled overlay should mount into, given its id.
 *
 * Returns `null` when no id is passed, which callers hand to Radix as
 * `container={undefined}` to keep the default `document.body` target.
 */
export function useBoundedContainer(containerId?: string): Element | null {
  // The layout shell is already mounted by the time this runs, so the target
  // resolves synchronously on first render — no mount-time flash.
  const [container, setContainer] = useState<Element | null>(() =>
    containerId ? document.getElementById(containerId) : null
  );

  useEffect(() => {
    setContainer(containerId ? document.getElementById(containerId) : null);
  }, [containerId]);

  return containerId ? container : null;
}

export default useBoundedContainer;
